import { createFileRoute } from "@tanstack/react-router";

import CannedResponses from "../pages/CannedResponses";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/livechat/canned-responses")({
  component: CannedResponsesRoute,
});

function CannedResponsesRoute() {
  return (
    <RequireAuth>
      <CannedResponses />
    </RequireAuth>
  );
}
